(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else if(typeof exports === 'object')
		exports["envision"] = factory(require("jquery"));
	else
		root["envision"] = factory(root["jQuery"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__1914__) => {
return 